import { useState, useRef, useEffect } from 'react';

import { FlyingCookieCoordinateTransition } from '@app/shared/types/flyingCookie';

const addPxUnit = (value: number) => `${value}px`;

export const useFlyingCookie = () => {
  const [cookie, setCookie] = useState<FlyingCookieCoordinateTransition | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, []);

  const animateCookie = (
    sourceElementRect: DOMRect | undefined,
    targetElementRect: DOMRect | undefined
  ) => {
    if (!sourceElementRect || !targetElementRect) {
      return;
    }

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    const startX = sourceElementRect.left + sourceElementRect.width / 2;
    const startY = sourceElementRect.top + sourceElementRect.height / 2;
    const moveToX = targetElementRect.left + targetElementRect.width / 2 - startX;
    const moveToY = targetElementRect.top + targetElementRect.height / 2 - startY;

    setCookie({
      startX: addPxUnit(startX),
      startY: addPxUnit(startY),
      moveToX: addPxUnit(moveToX),
      moveToY: addPxUnit(moveToY),
    });

    timeoutRef.current = setTimeout(() => {
      setCookie(null);
      timeoutRef.current = null;
    }, 700);
  };

  return { cookie, animateCookie };
};
